import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface CreateEntityStepProps {
  entityData: {
    name: string;
    type: string;
    details: any;
  };
  setEntityData: (data: any) => void;
  storyId: string | null;
  projectId: string | null;
}

export function CreateEntityStep({ entityData, setEntityData }: CreateEntityStepProps) {
  
  const inputClasses = "h-12 rounded-xl bg-muted/5 border-border/50 focus:border-primary/30 focus:ring-0 transition-all font-medium text-foreground placeholder:text-muted-foreground/30 shadow-none";
  const textareaClasses = "min-h-[140px] rounded-xl bg-muted/5 border-border/50 focus:border-primary/30 focus:ring-0 transition-all text-foreground placeholder:text-muted-foreground/30 shadow-none resize-none p-5 text-base leading-relaxed";
  const labelClasses = "text-[10px] font-bold uppercase tracking-wider text-muted-foreground/60 mb-2 block ml-1";

  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-2 duration-700">
      {/* Step Header matching Step 0 */}
      <div className="space-y-3">
        <h1 className="text-3xl font-bold tracking-tight text-foreground font-lora">
          Your main character
        </h1>
        <p className="text-muted-foreground text-sm leading-relaxed max-w-md">
          The soul of your story. Define the protagonist who will drive the emotional core of your narrative.
        </p>
      </div>

      <div className="space-y-6">
        {/* Internal conflict/motivation (Main Textarea) */}
        <div className="space-y-1">
          <Label htmlFor="character-description" className={labelClasses}>
            Internal Conflict / Motivation
          </Label>
          <Textarea
            id="character-description"
            placeholder="What drives them? What is their secret fear? What do they want more than anything?"
            value={entityData.details.description || ''}
            onChange={(e) => setEntityData({
              ...entityData,
              details: {
                ...entityData.details,
                description: e.target.value
              }
            })}
            className={textareaClasses}
            autoFocus
          />
        </div>

        {/* Name and Role Side-by-Side */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="space-y-1">
            <Label htmlFor="character-name" className={labelClasses}>
              Name
            </Label>
            <Input
              id="character-name"
              placeholder="e.g. Sarah Connor"
              value={entityData.name}
              onChange={(e) => setEntityData({ ...entityData, name: e.target.value })}
              className={inputClasses}
            />
          </div>

          <div className="space-y-1">
            <Label htmlFor="character-role" className={labelClasses}>
              Role / Archetype
            </Label>
            <Input
              id="character-role"
              placeholder="e.g. Reluctant Hero"
              value={entityData.details.role || ''}
              onChange={(e) => setEntityData({
                ...entityData,
                details: {
                  ...entityData.details,
                  role: e.target.value
                }
              })}
              className={inputClasses}
            />
          </div>
        </div>
      </div>
      
      {/* Tip footer */}
      <div className="pt-2">
        <p className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground/30 ml-1">
          Tip: You can add more characters and details later in Elements.
        </p>
      </div>
    </div>
  );
}
